const reLeadingDot = /^\./
export default reLeadingDot
